import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

const periods = ['daily', 'week', 'month', 'year'];

const periodLabel = (period, res) => {
    if (period === 'daily') return res.DIARIO;
    if (period === 'week') return res.SEMANAL;
    if (period === 'month') return res.MENSAL;
    return res.ANUAL;
};

const ClimateHistory = ({ state, res, modules, chart, onPeriodChange, onDateChange, onWeekChange, onMonthChange, onYearChange, onModuleChange }) => (
    <section className={`weather-panel weather-history ${state.activeWeatherView === 'history' ? 'is-visible' : ''}`}>
        <div className="weather-history-toolbar">
            <div className="weather-period-tabs">
                {periods.map(period => <button type="button" key={period} className={state.selectedHistoricType === period ? 'is-active' : ''} onClick={() => onPeriodChange(null, period)}>{periodLabel(period, res)}</button>)}
            </div>
            {state.selectedHistoricType === 'daily' && <TextField type="date" value={state.selectedDate} onChange={onDateChange} inputProps={{ max: state.maxSelectedDate }} />}
            {state.selectedHistoricType === 'week' && <TextField type="date" value={state.selectedWeekStart} onChange={onWeekChange} inputProps={{ max: state.maxSelectedDate }} />}
            {state.selectedHistoricType === 'month' && <TextField type="month" value={state.selectedMonth} onChange={onMonthChange} />}
            {state.selectedHistoricType === 'year' && <Select value={state.selectedYear} onChange={onYearChange}>{Array.from({ length: 6 }, (_, index) => String(new Date().getFullYear() - index)).map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}</Select>}
        </div>
        <div className="weather-module-tabs">
            {modules.map(module => <button type="button" key={module.value} disabled={module.disabled} className={state.selectedInfo === module.value ? 'is-active' : ''} onClick={() => onModuleChange(null, module.value)}>{module.label}</button>)}
        </div>
        <div className="weather-chart-shell">{chart}</div>
    </section>
);

export default ClimateHistory;
